import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {Close,LastPage,AllInclusive,Add,MoreVert,Edit,Delete,Done,Block,Visibility,Gavel,FilterList, FormatListNumbered,ConfirmationNumber,HourglassEmpty,Check} from '@material-ui/icons';

import { withLocalize,Translate } from "react-localize-redux";

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  CircularProgress,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Grid,
  Link,
  Slide
} from "@material-ui/core";

import Format from "date-fns/format";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import {useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import {TransportService,ReportingService,AdminService,FinanceService,groupBy} from "../../utils/web_config_2";


import UserInfo from "./login_info";

import DateFnsUtils from "@date-io/date-fns";

import axios from 'axios';

import Chart from 'react-apexcharts'

import Skeleton from '@material-ui/lab/Skeleton';
import Autocomplete from '@material-ui/lab/Autocomplete';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",
  },
  formTitle:{
    flexGrow:1,
},
paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    height:300,
    elevation:0
  },appBar: {
    position: 'relative',
  },title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  }
}));


 function ReportBranchV2() {
  const classes = useStyles1();

  // new offense dialog 

  const [open, setOpen] = useState(false);

  const [operatorData, setOperatorData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [reportsMessage,setReportsMessage]=useState("Loading...");
  const [reportTitle,setReportTitle]=useState("Branch Daily report");

  const [currency,setCurrency]=useState("");

  const history = useHistory();


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

//offenses table 


const columns = [
   {
    name: "branch",
    label: "Branch Name",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
      return (<Typography color="primary"><Link href="#" onClick={()=>{
        setOutletDialog(true);
        get_outlet(value);
      }}>
        {value}
      </Link>
      </Typography>
      );
   }
    }
   },
   {
     name: "tickets",
    label: "Total Tickets",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
     name: "amount",
    label: "Total Amount",
    options: {
     filter: true,
     sort: true,
    }
   }
 ];

 
 const options = {textLabels: {
  body: {
    noMatch: reportsMessage
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
    <Box>
      <Chip 
      className={classes.chip} 
      icon={ <Visibility/>} 
      color="primary" 
      variant="outlined" 
      label="View details" 
      onClick={()=>{
 var id=displayData[selectedRows.data[0]['index']]['data'][0];
 console.log("ticket id",id);
}} />
      </Box>
  ),
 };


 useEffect(()=>{

  var data = {};
  const data1 = localStorage.getItem("nx_op");
  if (data1 != null) {
    data = JSON.parse(data1);
  }

  setOperatorData(data);
 

  get_branch_report(data.token);
  get_branch(data.token);

 },[]);

 const getDate=()=>{
    return Format(new Date(), ["yyyy-MM-dd",]);
 }



 const [amounts,setAmounts]=useState([]);
 const [labels,setLabels]=useState([]); 
 const [revenue,setRevenue]=useState([]);


//  bus performance 

 const bus_performance= 
{options:{
    series: [],
    chart: {
    width: 380,
    type: 'pie',
  },
  
  labels: labels,
  legend: {
    position: 'right',
    itemMargin:{
        horizontal:0
    }
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 280,
        height:280
      },
      legend: {
        position: 'right'
      }
    }
  }]
  }
}




// get branches 

const [branches,setBranches]=useState([]);
const get_branch=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
    const branchInstance = axios.create(new TransportService().setHeaders(token)); 
    branchInstance.get("/api/v1/branching/getBranchs")
    .then(res=>{
        var objs=res.data;
        if(objs.length!=0){
            setBranches(objs.filter((o)=>o.organization.id==new UserInfo().ID));
        }else{
            enqueueSnackbar("No branches available!", { 
                variant: 'info',
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'right',
              },
            });
        }
    })
    .catch(err=>{
enqueueSnackbar(err.message, { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    });
}


//   get daily branch report 
const [totalTickets,setTotalTickets]=useState(0);
const [totalAmount,setTotalAmount]=useState(0);
const [totalsByCurrencies, setTotalsByCurrencies] = useState([]);

const [reportLoad,setReportLoad]=useState(false);
const [reports,setReports]=useState([]);
const get_branch_report=(token)=>{
setReportLoad(true);
axios.defaults.baseURL = new ReportingService().BASE_URL;
const reportInstance = axios.create(new ReportingService().setHeaders(token));
  reportInstance.post('/extra-reports/getBranchReportDetails',
{
  "company_id": ""+new UserInfo().ORG_ID+"",
  // "end_date": "2021-09-25 23:59:59",
  // "start_date": "2021-09-24 00:00:00"
  "end_date": `${Format(new Date(), ["yyyy-MM-dd",])} 23:59:59`,
  "start_date": `${Format(new Date(), ["yyyy-MM-dd",])} 00:00:00`,
  // "end_date": "2024-09-17 00:00:00",
  // "start_date": "2024-03-01 00:00:00"
}

)
.then(res=>{
    var objs=res.data.data;
    var curr="";

    console.log("===== branch  report =====");
    console.log(objs);
    if(objs.length==0){
        setReportsMessage("No Branch report available today");
    }else{
        var performance=[];
        var lebals=[];
        var total=objs.reduce((a, b)=>{
            return a + parseInt(b.total_income);
        }, 0);
        var tickets=objs.reduce((a, b)=>{
            return a + parseInt(b.total_tickets);
        }, 0);
        
        setTotalAmount(total);
        setTotalTickets(tickets);

        var currTotals = [];

        objs.map((o)=>{
            o['amount']=formatMoney(o.amount,0) + " RWF";
            var percentage=(parseInt(o.total_income)/total)*100;
          
            performance.push(percentage);
            if(o['branch_name']==null){
                lebals.push("null");
                o['branch_name']="null";
              }else{
                lebals.push(o['branch_name']);
              }
              curr= o.currency;
              
              if(currTotals[o.currency]){
                currTotals[o.currency].total_tickets += parseInt(o.total_tickets);
                currTotals[o.currency].total_income += parseInt(o.total_income);
              } else {
                currTotals[o.currency] = {total_tickets: parseInt(o.total_tickets), total_income: parseInt(o.total_income)};
              }

        });

        setTotalsByCurrencies(currTotals);


        let unique_branch =lebals.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
        let unique_percentage=[];
        let unique_revenue=[];
        var grouped=[];
       
          for(var i=0;i<unique_branch.length;i++){
            var to=0;
            var r=0;

            var pos=0;
            var validator=0;
            var kiosk=0;
            var app_web=0;
            var ussd=0;


            var curr="";
            for(var a=0;a<objs.length;a++){
              if(objs[a]['branch_name']==unique_branch[i]){
                r=r+parseInt(objs[a]['total_income']);
                to=to+parseInt(objs[a]['total_tickets']);
                
                pos=pos+parseInt(objs[a]['pos']);
                validator=validator+parseInt(objs[a]['validator']);
                kiosk=kiosk+parseInt(objs[a]['kiosk']);
                app_web=app_web+parseInt(objs[a]['app_web']);
                ussd=ussd+parseInt(objs[a]['ussd']);

                curr= objs[a]['currency'];
              }
            }
            var obj={branche_name:unique_branch[i],total_tickets:to,amount:r+" "+curr,pos:pos,validator:validator,kiosk:kiosk,app_web:app_web,ussd:ussd};
            grouped.push(obj);
            unique_revenue.push(r);
            unique_percentage.push(to);
          }
        
          setAmounts(unique_percentage);
          setLabels(unique_branch);
          setRevenue(unique_revenue);


          console.log("grouped");
          console.log(grouped);

        setReports(objs);
    }
   
    setReportLoad(false);
    setCurrency(curr);
})
.catch(err=>{
   
    setReportLoad(false);
    if(err.message){
      setReportsMessage(err.message);
      enqueueSnackbar(err.message,
        { 
          variant: 'error'
      });
    }

    if(err.response){
      setReportsMessage(err.response.data.message);
      enqueueSnackbar(err.response.data.message,
        { 
          variant: 'error'
      });
    }
});

}


// filter report 


// filter dialog 
const [filterDialog,setFilterDialog]=useState(false);


// filter barnch report

const [startDate,setStartDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
const [endDate,setEndDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
const [branchName,setBranchName]=useState({value:"  ",error:""});

const filter_report=()=>{
    if(branchName.value!==""){

        // with specific barnch

        setReports([]);
        if(startDate.value==endDate.value){

          // day specific barnch 


            setReportLoad(true);
            setAmounts([]);
            setLabels([]);
            setRevenue([]);
            axios.defaults.baseURL = new ReportingService().BASE_URL;
            const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token)); 
          filterInstance.post('/extra-reports/getBranchReportDetails',{
              "end_date": `${endDate.value} 23:59:59` ,
              "start_date": `${startDate.value} 00:00:00`,
              "company_id":new UserInfo().ORG_ID
              }) 
            .then(res=>{
                var objs=res.data.data;

                var currTotals = [];


                

                objs.map((o)=>{
                    if(currTotals[o.currency]){
                      currTotals[o.currency].total_tickets += parseInt(o.total_tickets);
                      currTotals[o.currency].total_income += parseInt(o.total_income);
                    } else {
                      currTotals[o.currency] = {total_tickets: parseInt(o.total_tickets), total_income: parseInt(o.total_income)};
                    }
                });

                        setTotalsByCurrencies(currTotals);
        
                // objs.map((o,i)=>{
                //   o['amount']=o['total_income'];
                //   o['amount']=formatMoney(o.total_income,0)+ o.currency;
                // });

        if(objs.length==0){
            setReportsMessage("No Branch report available today");
            setFilterDialog(false);
            setReportLoad(false);
        }else{
            // var performance=[];
          var lebals=[];
          var total=objs.reduce((a, b)=>{
              return a + parseInt(b.total_income);
          }, 0);
          var tickets=objs.reduce((a, b)=>{
              return a + parseInt(b.total_tickets);
          }, 0);
          
          setTotalAmount(total);
          setTotalTickets(tickets);



          // group by branch name 

          let unique_percentage=[];
          let unique_revenue=[];

          let unique_branch=[];

          var branchGroup=[];

          var groupByBranch = groupBy(objs, function(item) {
            return [item.branch_name,item.currency];
        });


        groupByBranch.map((o)=>{

          var branches=o;
          var branch=branches[0]['branch_name'];
          var currency=branches[0]['currency'];
          unique_branch.push(branch);
          if(branch==null){
            lebals.push("null");
            branch="null";
          }else{
            lebals.push(branch);
          }

          // total amount

          var total_amount=branches.reduce(function (sum, amount) {
            return sum + parseInt(amount.total_income);
        }, 0);

          // total tickets 
        var total_tickets=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.total_tickets);
        }, 0);

        var pos=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.pos);
        }, 0);

        var validator=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.validator);
        }, 0);
        var kiosk=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.kiosk);
        }, 0);

        var app_web=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.app_web);
        }, 0);
        var ussd=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.ussd);
        }, 0);




        unique_revenue.push(total_amount);
        unique_percentage.push(total_tickets);

        branchGroup.push({ branche_name:branch,total_tickets:total_tickets,amount:total_amount+" "+currency,ussd:ussd,app_web:app_web,kiosk:kiosk,validator:validator,pos:pos});
      
        });
        setReports(objs);

          
            setAmounts(unique_percentage);
            setLabels(unique_branch);
            setRevenue(unique_revenue);
            setReportTitle(" From: "+startDate.value+" To: "+endDate.value);
          
          // setReports(grouped);
          setFilterDialog(false);
          setReportLoad(false);
            }})
            .catch(err=>{
            setReportLoad(false);
              if(err.message){
                setReportsMessage(err.message);
                enqueueSnackbar(err.message,
                  { 
                    variant: 'error'
                });
              }
          
              if(err.response){
                setReportsMessage(err.response.data.message);
                enqueueSnackbar(err.response.data.message,
                  { 
                    variant: 'error'
                });
              }
            });
        }else if(startDate.value>endDate.value || startDate.value<endDate.value){
    
          // duration specific branch 

          setReportLoad(true);
          setAmounts([]);
          setLabels([]);
          setRevenue([]);
          axios.defaults.baseURL = new ReportingService().BASE_URL;
          const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token)); 
          filterInstance.post('/extra-reports/getBranchReportDetails',{
            "end_date": `${endDate.value} 23:59:59`,
            "start_date": `${startDate.value} 00:00:00`,
            "company_id":new UserInfo().ORG_ID
            }) 
          .then(res=>{
              var objs=res.data.data;
              // objs.map((o,i)=>{
              //   o['amount']=o['total_income'];
              //   o['amount']=formatMoney(o.total_income,0)+ o.currency;
              // });


      if(objs.length==0){
          setReportsMessage("No Branch report available today");
          setFilterDialog(false);
          setReportLoad(false);
      }else{

                  var currTotals = [];    

                  objs.map((o)=>{
                      if(currTotals[o.currency]){
                        currTotals[o.currency].total_tickets += parseInt(o.total_tickets);
                        currTotals[o.currency].total_income += parseInt(o.total_income);
                      } else {
                        currTotals[o.currency] = {total_tickets: parseInt(o.total_tickets), total_income: parseInt(o.total_income)};
                      }
                  });

        setTotalsByCurrencies(currTotals);

          // var performance=[];
          var lebals=[];
          var total=objs.reduce((a, b)=>{
              return a + parseInt(b.total_income);
          }, 0);
          var tickets=objs.reduce((a, b)=>{
              return a + parseInt(b.total_tickets);
          }, 0);
          
          setTotalAmount(total);
          setTotalTickets(tickets);
          
          
          
        



          // group by branch name 

          let unique_percentage=[];
          let unique_revenue=[];

          let unique_branch=[];

          var branchGroup=[];

          var groupByBranch = groupBy(objs, function(item) {
            return [item.branch_name,item.currency];
        });


        groupByBranch.map((o)=>{

          var branches=o;
          var branch=branches[0]['branch_name'];
          var currency=branches[0]['currency'];
          unique_branch.push(branch);
          if(branch==null){
            lebals.push("null");
            branch="null";
          }else{
            lebals.push(branch);
          }

          var total_amount=branches.reduce(function (sum, amount) {
            return sum + parseInt(amount.total_income);
        }, 0);
        var total_tickets=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.total_tickets);
        }, 0);

        var pos=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.pos);
        }, 0);

        var validator=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.validator);
        }, 0);
        var kiosk=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.kiosk);
        }, 0);

        var app_web=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.app_web);
        }, 0);
        var ussd=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.ussd);
        }, 0);




        unique_revenue.push(total_amount);
        unique_percentage.push(total_tickets);

        branchGroup.push({ branche_name:branch,total_tickets:total_tickets,amount:total_amount+" "+currency,ussd:ussd,app_web:app_web,kiosk:kiosk,validator:validator,pos:pos});
      
      
        });

        setReports(objs);


         

          
            setAmounts(unique_percentage);
            setLabels(unique_branch);
            setRevenue(unique_revenue);
            setReportTitle(" From: "+startDate.value+" To: "+endDate.value);
          
          // setReports(grouped);
          setFilterDialog(false);
          setReportLoad(false);
          }})
          .catch(err=>{
            setReportLoad(false);
            if(err.message){
              setReportsMessage(err.message);
              enqueueSnackbar(err.message,
                { 
                  variant: 'error'
              });
            }
        
            if(err.response){
              setReportsMessage(err.response.data.message);
              enqueueSnackbar(err.response.data.message,
                { 
                  variant: 'error'
              });
            }
          });
    
        }

    }else if(branchName.value==""){

    //  all branches

    setReports([]);
    if(startDate.value==endDate.value){

      // day all buses 


        setReportLoad(true);
        setAmounts([]);
        setLabels([]);
        setRevenue([]);
        axios.defaults.baseURL = new ReportingService().BASE_URL;
        const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token)); 
      filterInstance.post('/extra-reports/getBranchReportDetails',{
          "end_date": `${endDate.value} 23:59:59`,
          "start_date": `${startDate.value} 00:00:00`,
          "company_id":new UserInfo().ORG_ID
          }) 
        .then(res=>{
            var objs=res.data.data;
    
    if(objs.length==0){
        setReportsMessage("No Branch report available today");
        setFilterDialog(false);
        setReportLoad(false);
    }else{
      // objs.map((o,i)=>{
      //   o['amount']=o['total_income'];
      //   o['amount']=formatMoney(o.total_income,0)+ o.currency;
      // });
      // var performance=[];
      var lebals=[];
      var total=objs.reduce((a, b)=>{
          return a + parseInt(b.total_income);
      }, 0);
      var tickets=objs.reduce((a, b)=>{
          return a + parseInt(b.total_tickets);
      }, 0);
      
      setTotalAmount(total);
      setTotalTickets(tickets);

      var currTotals = [];

      objs.map((o)=>{
         if(currTotals[o.currency]){
          currTotals[o.currency].total_tickets += parseInt(o.total_tickets);
          currTotals[o.currency].total_income += parseInt(o.total_income);
        } else {
          currTotals[o.currency] = {total_tickets: parseInt(o.total_tickets), total_income: parseInt(o.total_income)};
        }
      });

              setTotalsByCurrencies(currTotals);


      // group by branch name 

      let unique_percentage=[];
      let unique_revenue=[];

      let unique_branch=[];

      var branchGroup=[];

      var groupByBranch = groupBy(objs, function(item) {
        return [item.branch_name,item.currency];
    });


    groupByBranch.map((o,i)=>{

      var branches=o;
      let branch=branches[0]['branch_name'];

      var currency=branches[0]['currency'];
     

      if(branch==null){
        lebals.push("null");
        branch="null";
        unique_branch.push("null");
      }else{
        lebals.push(branch);
        unique_branch.push(branch);
      }


    var total_amount=branches.reduce(function (sum, amount) {
        return sum + parseInt(amount.total_income);
    }, 0);

    var total_tickets=branches.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.total_tickets);
    }, 0);

           var pos=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.pos);
        }, 0);

        var validator=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.validator);
        }, 0);
        var kiosk=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.kiosk);
        }, 0);

        var app_web=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.app_web);
        }, 0);
        var ussd=branches.reduce(function (sum, tickets) {
          return sum + parseInt(tickets.ussd);
        }, 0);




        unique_revenue.push(total_amount);
        unique_percentage.push(total_tickets);

        branchGroup.push({ branche_name:branch,total_tickets:total_tickets,amount:total_amount+" "+currency,ussd:ussd,app_web:app_web,kiosk:kiosk,validator:validator,pos:pos});
      
  
    });
    setReports(objs);


        setAmounts(unique_percentage);
        setLabels(unique_branch);
        setRevenue(unique_revenue);
        setReportTitle(" From: "+startDate.value+" To: "+endDate.value);
      
      // setReports(grouped);
      setFilterDialog(false);
      setReportLoad(false);
        }
      })
        .catch(err=>{
          setReportLoad(false);
          if(err.message){
            setReportsMessage(err.message);
            enqueueSnackbar(err.message,
              { 
                variant: 'error'
            });
          }
      
          if(err.response){
            setReportsMessage(err.response.data.message);
            enqueueSnackbar(err.response.data.message,
              { 
                variant: 'error'
            });
          }
        });
    }else if(startDate.value>endDate.value || startDate.value<endDate.value){

      // duration all buses 

      setReportLoad(true);
      setAmounts([]);
      setLabels([]);
      setRevenue([]);
      setReportTitle(" From: "+startDate.value+" To: "+endDate.value);
      axios.defaults.baseURL = new ReportingService().BASE_URL;
      const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token)); 
      filterInstance.post('/extra-reports/getBranchReportDetails',{
        "end_date":endDate.value + " 23:59:59",
        "start_date":startDate.value + " 00:00:00",
        "company_id":new UserInfo().ORG_ID
        }) 
      .then(res=>{
          var objs=res.data.data;
  console.log("=====  report =====",objs);
  if(objs.length==0){
      setReportsMessage("No Branch report available today");
      setFilterDialog(false);
      setReportLoad(false);
  }else{
    // objs.map((o,i)=>{
    //   o['amount']=o['total_income'];
    //   o['amount']=formatMoney(o.total_income,0)+ o.currency;
    // });
      // var performance=[];
      var lebals=[];
      var total=objs.reduce((a, b)=>{
          return a + parseInt(b.total_income);
      }, 0);
      var tickets=objs.reduce((a, b)=>{
          return a + parseInt(b.total_tickets);
      }, 0);
      
      setTotalAmount(total);
      setTotalTickets(tickets);


      var currTotals = [];

      objs.map((o)=>{
          
        if(currTotals[o.currency]){
          currTotals[o.currency].total_tickets += parseInt(o.total_tickets);
          currTotals[o.currency].total_income += parseInt(o.total_income);
        } else {
          currTotals[o.currency] = {total_tickets: parseInt(o.total_tickets), total_income: parseInt(o.total_income)};
        }
      });

        setTotalsByCurrencies(currTotals);


      // group by branch name 

      let unique_percentage=[];
      let unique_revenue=[];

      let unique_branch=[];

      var branchGroup=[];

      var groupByBranch = groupBy(objs, function(item) {
        return [item.branch_name,item.currency];
    });


    groupByBranch.map((o,i)=>{

      var branches=o;
      let branch=branches[0]['branch_name'];

      var currency=branches[0]['currency'];
     

      if(branch==null){
        lebals.push("null");
        branch="null";
        unique_branch.push("null");
      }else{
        lebals.push(branch);
        unique_branch.push(branch);
      }


    var total_amount=branches.reduce(function (sum, amount) {
        return sum + parseInt(amount.total_income);
    }, 0);

    var total_tickets=branches.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.total_tickets);
    }, 0);

    var pos=branches.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.pos);
    }, 0);

    var validator=branches.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.validator);
    }, 0);
    var kiosk=branches.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.kiosk);
    }, 0);

    var app_web=branches.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.app_web);
    }, 0);
    var ussd=branches.reduce(function (sum, tickets) {
      return sum + parseInt(tickets.ussd);
    }, 0);




    unique_revenue.push(total_amount);
    unique_percentage.push(total_tickets);

    branchGroup.push({ branche_name:branch,total_tickets:total_tickets,amount:total_amount+" "+currency,ussd:ussd,app_web:app_web,kiosk:kiosk,validator:validator,pos:pos});
  
  
    });
    setReports(objs);




        setAmounts(unique_percentage);
        setLabels(unique_branch);
        setRevenue(unique_revenue);
        setReportTitle(" From: "+startDate.value+" To: "+endDate.value);
      
      // setReports(grouped);
      setFilterDialog(false);
      setReportLoad(false);
      }})
      .catch(err=>{
        setReportLoad(false);
        if(err.message){
          setReportsMessage(err.message);
          enqueueSnackbar(err.message,
            { 
              variant: 'error'
          });
        }
    
        if(err.response){
          setReportsMessage(err.response.data.message);
          enqueueSnackbar(err.response.data.message,
            { 
              variant: 'error'
          });
        }
      });

    }

    }
}



// outlet report



const columns1 = [
  {
    name: "agent",
    label: "Agent Name",
    options: {
     filter: true,
     sort: true,
     customBodyRender: (value, tableMeta, updateValue) => {
      return (<Button color="primary" onClick={()=>{
        get_route_outlet_report(value);
        setRouteDialog(true);
      }}>{value}</Button>
      );
   }
    }
   },
   
   {
     name: "tickets",
    label: "Total Tickets",
    options: {
     filter: true,
     sort: true,
    }
   }
  ,
  {
    name: "amount",
    label: "Total Amount",
    options: {
     filter: true,
     sort: true,
    }
   }
 ];

 
 const options1 = {textLabels: {
  body: {
    noMatch: "No Agent Branch Report"
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 100,
   elevation:0,
 };





// branch outlet report


const [outletDialog,setOutletDialog]=useState(false);
const [outletLoad,setOutletLoad]=useState(false);
const [outlets,setOutlets]=useState([]);

const get_outlet=(branch)=>{
  setOutlets([]);
  setOutletLoad(true);
  setBranchName({value: branch, error:''});

  axios.defaults.baseURL = new ReportingService().BASE_URL;
  const filterInstance = axios.create(new ReportingService().setHeaders(operatorData.token)); 
  filterInstance.post('/extra-reports/getAgentBranchReport',
  {
    "organization_id": new UserInfo().ORG_ID,
    "branch": branch,
    // "end_date": "2024-09-17 00:00:00",
    // "start_date": "2024-03-01 00:00:00",

    "end_date": `${endDate.value} 23:59:59`,
    "start_date": `${startDate.value} 00:00:00`


    // "end_date": "2021-09-25 23:59:59",
    // "start_date": "2021-09-24 00:00:00"

    
    // "branch_name":branch,
    // "start_date":startDate.value,
    // "end_date":endDate.value
  }
    ).then((res)=>{

      var data=res.data.data;
      data.map((o,i)=>{
        o['currency']= o.currency;
      });
      console.log(data);
      setOutlets(data);
      setOutletLoad(false);
     

    })
    .catch((error)=>{
      setOutletLoad(false);

    })

}


// format money


function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? "-" : "";

    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;

    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  } catch (e) {
    console.log(e)
  }
};

// route outlet report table 



const columns2 = [
  {
    name: "route",
    label: "Route",
    options: {
     filter: true,
     sort: true,
  //    customBodyRender: (value, tableMeta, updateValue) => {
  //     return (<Button color="primary" onClick={()=>{
  //       get_outlet_user_report(value);
  //     }}>{value}</Button>
  //     );
  //  }
    }
   },
  {
    name: "tickets",
   label: "Total Tickets",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
    name: "amount",
    label: "Total amount",
    options: {
     filter: true,
     sort: true,
    }
   }

 ];

 
 const options2 = {textLabels: {
  body: {
    noMatch: "No report"
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 100,
   elevation:0,
 };

// route outlet report 






const [routeDialog,setRouteDialog]=useState(false);
const [routeLoad,setRouteLoad]=useState(false);
const [routes,setRoutes]=useState([]);

const [outlet,setOutlet]=useState("");

const get_route_outlet_report=(outletVal)=>{
  setRouteLoad(true);
  setRoutes([]);
  setOutlet(outletVal);
  axios.defaults.baseURL = new ReportingService().BASE_URL;
  const routeInstance = axios.create(new ReportingService().setHeaders(operatorData.token)); 
  routeInstance.post('/extra-reports/getRouteAgentBranchReport',{

    "agent": outletVal,
    "branch": branchName.value,
    "organization_id": new UserInfo().ORG_ID,
    "end_date": `${endDate.value} 23:59:59`,
    "start_date": `${startDate.value} 00:00:00`


    // "outlet":outletVal,
    // "end_date":endDate.value+" 23:59:00",
    // "start_date":startDate.value+" 00:00:00",
    // "end_date": "2021-09-25 23:59:59",
    // "start_date": "2021-09-24 00:00:00",
    // "start_date":startDate.value,
    // "end_date":endDate.value,
    // "company_id":new UserInfo().ORG_ID
})
  .then(res=>{
    var objs=res.data.data;
    setRoutes(objs);
    setRouteLoad(false);
  })
  .catch(err=>{
    setRouteLoad(false);
  })

};






// route outlet user  report table 



const columns3 = [
  {
    name: "pos_user",
    label: "POS User",
    options: {
     filter: true,
     sort: true
    }
   },
  {
   name: "intermediate_route",
   label: "Route",
   options: {
    filter: true,
    sort: true,
   }
  },
 
  {
    name: "number_of_ticket",
    label: "Tickets",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "amount",
    label: "Total amount",
    options: {
     filter: true,
     sort: true,
    }
   }
   

 ];

 
 const options3 = {textLabels: {
  body: {
    noMatch: "No report"
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 100,
   elevation:0,
 };


 const [outletUserDialog,setOUtletUserDialog]=useState(false);
 const [outletUserLoad,setOutletUserLoad]=useState(false);
 const [outletUserReport,setOutletUserReport]=useState([]);

 const get_outlet_user_report=(intermediate)=>{
   setOutletUserLoad(true);
   setOutletUserReport([]);
   setOUtletUserDialog(true);
   axios.defaults.baseURL = new ReportingService().BASE_URL;
   const routeInstance = axios.create(new ReportingService().setHeaders(operatorData.token)); 
   routeInstance.post('/extra-reports/pullOutletReportByIntemediateRoute',{
    "intermidiate_route": intermediate,
    "outlet":outlet,
    "end_date":endDate.value+" 23:59:00",
    "start_date":startDate.value+" 00:00:00",
    //  "end_date": "2021-09-25 23:59:59",
    //  "start_date": "2021-09-24 00:00:00",
     // "start_date":startDate.value,
     // "end_date":endDate.value,
     "company_id":new UserInfo().ORG_ID
 })
   .then(res=>{
     var objs=res.data.data;
     setOutletUserReport(objs);
     setOutletUserLoad(false);
   })
   .catch(err=>{
    setOutletUserLoad(false);
   })

 }


  return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<div className={classes.root}>
				<Box display='flex'>
					<Box
						display='flex'
						alignItems='center'
						mt={2}
						className={classes.formTitle}
					>
						<Box mr={1}>
							<ConfirmationNumber fontSize='large' color='primary' />
						</Box>{' '}
						<Typography variant='h5' color='default'>
							<b>Branch Report</b>
						</Typography>
					</Box>

					<Button
						color='primary'
						variant='outlined'
						startIcon={<FilterList />}
						onClick={() => {
							setBranchName({ value: '', error: '' });
							setFilterDialog(true);
						}}
					>
						Filter
					</Button>
				</Box>

				<Box mt={2}>
					<Grid container spacing={2}>
						{/* <Grid item xs={12} md={12}>
							<Paper className={classes.paper1} elevation={0}>
								<Grid container>
									<Grid item xs={12} md={12}>
										<Box display='flex' justifyContent='center'>
											<Typography variant='h6'>{reportTitle}</Typography>
										</Box>
									</Grid>
									<Grid item xs={12} md={12}>
										<Chart
											options={revenue_bus.options}
											series={revenue_bus.options.series}
											type='bar'
											height='300px'
										/>
									</Grid>
								</Grid>
							</Paper>
						</Grid> */}
						<Grid item md={12} lg={12} sm={12} xs={12}>
							{reportLoad && <LinearProgress />}
							<MUIDataTable
								title={reportTitle}
								data={reports}
								columns={columns}
								options={options}
							/>
						</Grid>
						{/* <Grid item md={4} lg={4} sm={12} xs={12}>
							{reportLoad ? (
								<Paper className={classes.paper} elevation={0}>
									<Grid container>
										<Grid item xs={12} md={12}>
											<Box>
												<Typography variant='h6' className={classes.title}>
													Branch Performance
												</Typography>
											</Box>
										</Grid>

										<Grid item xs={12} md={12}>
											<Grid item lg={12} sm={12} xs={12} md={12}>
												<Box>
													<Box display='flex' justifyContent='center'>
														<Skeleton
															animation='wave'
															variant='circle'
															width={200}
															height={200}
														/>
													</Box>
												</Box>
											</Grid>
										</Grid>
									</Grid>
								</Paper>
							) : (
								<Paper className={classes.paper} elevation={0}>
									<Grid container>
										<Grid item xs={12} md={12}>
											<Box>
												<Typography variant='h6' className={classes.title}>
													Branch Performance
												</Typography>
											</Box>
										</Grid>

										<Grid item xs={12} md={12}>
											<Grid item md={12} lg={12} xs={6} md={8}>
												<Chart
													options={bus_performance.options}
													series={amounts}
													type='pie'
													width={'100%'}
													height={'100%'}
												/>
											</Grid>
										</Grid>

										<Grid container spacing={2}>
											{Object.entries(totalsByCurrencies).map(
												([currency, totals]) => (
													<>
														<Grid item md={6} xs={12}>
															<Grid container>
																<Grid item xs={12}>
																	<Typography>
																		Total Tickets ({currency})
																	</Typography>
																</Grid>
																<Grid item xs={12}>
																	<Typography variant='h5'>
																		{totals.total_tickets}
																	</Typography>
																</Grid>
															</Grid>
														</Grid>
														<Grid item md={6} xs={12}>
															<Grid container>
																<Grid item xs={12}>
																	<Typography>
																		Total Amount ({currency})
																	</Typography>
																</Grid>
																<Grid item xs={12}>
																	<Typography variant='h5'>
																		{formatMoney(totals.total_income, 0) +
																			' ' +
																			currency}
																	</Typography>
																</Grid>
															</Grid>
														</Grid>
													</>
												)
											)}
										</Grid>
									</Grid>
								</Paper>
							)}
						</Grid> */}
					</Grid>
				</Box>
			</div>

			{/* filter dialog  */}

			<Dialog
				maxWidth='sm'
				fullWidth
				open={filterDialog}
				onClose={() => {
					setFilterDialog(true);
				}}
				aria-labelledby='filter'
				aria-describedby='filter'
			>
				<DialogTitle id='filter'>{'Filter'}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						<Box>
							{/* <Box mt={1}>
								<Autocomplete
									size='small'
									options={branches}
									getOptionLabel={(option) => option.name}
									fullWidth
									onChange={(event, newValue) => {
										if (newValue != null) {
											setBranchName({ value: newValue.name, error: '' });
										}
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											label='Select Branch'
											variant='outlined'
										/>
									)}
								/>
							</Box> */}

							<Box mt={1}>
								<DatePicker
									fullWidth
									disableToolbar
									variant='inline'
									format='yyyy-MM-dd'
									margin='dense'
									autoOk
									label='Start date'
									value={startDate.value}
									inputVariant='outlined'
									onChange={(v) => {
										console.log('choosen1: ', Format(v, ['yyyy-MM-dd']));

										setStartDate({
											value: Format(v, ['yyyy-MM-dd']),
											error: '',
										});
									}}
									InputProps={{
										disableUnderline: true,
										style: { paddingRight: 0 },
									}}
								/>
							</Box>
							<Box mt={1}>
								<DatePicker
									fullWidth
									disableToolbar
									variant='inline'
									format='yyyy-MM-dd'
									margin='dense'
									autoOk
									label='End date'
									value={endDate.value}
									inputVariant='outlined'
									onChange={(v) => {
										console.log('choosen2: ', v);
										setEndDate({ value: Format(v, ['yyyy-MM-dd']), error: '' });
									}}
									InputProps={{
										disableUnderline: true,
										style: { paddingRight: 0 },
									}}
								/>
							</Box>
						</Box>
					</DialogContentText>
				</DialogContent>

				<DialogActions>
					<Button
						onClick={() => {
							setFilterDialog(false);
						}}
						color='secondary'
						className={classes.btn}
					>
						<Typography>Close</Typography>
					</Button>

					<Button
						onClick={() => {
							filter_report();
						}}
						color='primary'
						variant='contained'
						className={classes.btn}
					>
						{reportLoad ? (
							<CircularProgress size={25} color='secondary' />
						) : (
							<Typography>View</Typography>
						)}
					</Button>
				</DialogActions>
			</Dialog>

			<Dialog
				fullScreen
				open={outletDialog}
				onClose={() => {}}
				TransitionComponent={Transition}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
							edge='start'
							color='inherit'
							onClick={() => {
								setOutletDialog(false);
							}}
							aria-label='close'
						>
							<Close />
						</IconButton>
						<Typography variant='h6' className={classes.title}>
							Agent Branch Report
						</Typography>

						<Button
							autoFocus
							color='inherit'
							onClick={() => {
								setOutletDialog(false);
							}}
						>
							Close
						</Button>
					</Toolbar>
				</AppBar>

				<Box mt={2}>
					{outletLoad && <LinearProgress />}
					<MUIDataTable
						title={'Agent Branch Report'}
						data={outlets}
						columns={columns1}
						options={options1}
					/>
				</Box>
			</Dialog>

			{/* route outlet report */}

			<Dialog
				fullScreen
				open={routeDialog}
				onClose={() => {
					setRouteDialog(false);
				}}
				TransitionComponent={Transition}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
							edge='start'
							color='inherit'
							onClick={() => {
								setRouteDialog(false);
							}}
							aria-label='close'
						>
							<Close />
						</IconButton>
						<Typography variant='h6' className={classes.title}>
							Routes
						</Typography>

						<Button
							autoFocus
							color='inherit'
							onClick={() => {
								setRouteDialog(false);
							}}
						>
							Close
						</Button>
					</Toolbar>
				</AppBar>

				<Box mt={2}>
					{routeLoad && <LinearProgress />}
					<MUIDataTable
						title={'Route Outlet'}
						data={routes}
						columns={columns2}
						options={options2}
					/>
				</Box>
			</Dialog>

			{/* outlet user report  */}

			<Dialog
				fullScreen
				open={outletUserDialog}
				onClose={() => {
					setOUtletUserDialog(false);
				}}
				TransitionComponent={Transition}
			>
				<AppBar className={classes.appBar}>
					<Toolbar>
						<IconButton
							edge='start'
							color='inherit'
							onClick={() => {
								setOUtletUserDialog(false);
							}}
							aria-label='close'
						>
							<Close />
						</IconButton>
						<Typography variant='h6' className={classes.title}>
							Routes
						</Typography>

						<Button
							autoFocus
							color='inherit'
							onClick={() => {
								setOUtletUserDialog(false);
							}}
						>
							Close
						</Button>
					</Toolbar>
				</AppBar>

				<Box mt={2}>
					{outletUserLoad && <LinearProgress />}
					<MUIDataTable
						title={'Route Outlet User Report'}
						data={outletUserReport}
						columns={columns3}
						options={options3}
					/>
				</Box>
			</Dialog>
		</MuiPickersUtilsProvider>
	);
}

export default withLocalize(ReportBranchV2);